import Router from './router/Router'
import { QueryClient, QueryClientProvider, QueryCache } from 'react-query'
import { HelmetProvider } from 'react-helmet-async'
import { ReactQueryDevtools } from 'react-query/devtools'

const spCache = new QueryCache()
export const queryClient = new QueryClient({
  queryCache: spCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 3600000 // twentyFourHoursInMs
    }
  }
})

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <Router />
        {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools initialIsOpen={false} />}
      </HelmetProvider>
    </QueryClientProvider>
  )
}
export default App
